"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/Button";
import { AlertCircle, RefreshCw } from "lucide-react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Music Analysis Page Error:", error);
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center border border-gray-100">
        <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-6">
          <AlertCircle className="w-8 h-8 text-red-500" />
        </div>
        
        <h2 className="text-2xl font-bold text-gray-900 mb-3">
          오류가 발생했습니다
        </h2>
        
        <p className="text-gray-600 mb-6 leading-relaxed">
          음악 분석 페이지를 불러오는 중 문제가 발생했습니다.<br />
          잠시 후 다시 시도해주세요.
        </p>

        <div className="bg-gray-50 rounded-lg p-4 mb-6 text-left overflow-auto max-h-40">
          <p className="text-xs text-gray-500 font-mono break-all">
            {error.message || "알 수 없는 오류"}
            {error.digest && <span className="block mt-1 text-gray-400">Digest: {error.digest}</span>}
          </p>
        </div>

        <div className="flex gap-3 justify-center">
          <Button
            onClick={() => window.location.href = "/"}
            variant="outline"
            className="flex-1"
          >
            홈으로
          </Button>
          <Button
            onClick={() => reset()}
            className="flex-1 bg-gradient-to-r from-teal-500 to-purple-500 hover:from-teal-600 hover:to-purple-600 text-white border-0"
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            다시 시도
          </Button>
        </div>
      </div>
    </div>
  );
}
